import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'VButton',
  props: {
    secondary: { type: Boolean },
    disabled: { type: Boolean },
    big: { type: Boolean },
    density: { type: Boolean },
    clear: { type: Boolean },
    red: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { secondary?: boolean, disabled?: boolean, big?: boolean, density?: boolean, clear?: boolean, red?: boolean }





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["v-button", { secondary: __props.secondary, disabled: __props.disabled, big: __props.big, density: __props.density, clear: __props.clear, red: __props.red }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})